import { XCircleIcon } from '@heroicons/react/20/solid';
import { lazy, Suspense } from 'react';

import { useAppDispatch, useAppSelector } from '../../../store';
import { uiActions } from '../../ui/slice';
import { NewResource, Resource } from '../types';
import { saveResource } from '../actions';
import { Modal } from '../../ui/components/Modal';

const ResourceEditor = lazy(() => import('./ResourceEditor').then(module => ({ default: module.ResourceEditor })));

export const EditorModal = () => {

  const currentModalPayload = useAppSelector(state => state.ui.modalPayload);
  const dispatch = useAppDispatch();

  const closeModal = () => dispatch(uiActions.setCurrentModal(null));

  const handleSave = (resource: NewResource) => {
    dispatch(saveResource(resource));
  };

  return (
    <Modal
      height={90}
      hide={closeModal}
      modalKey='resourceEditor'
      width={75}
    >
      <button
        className='absolute right-2 top-2 size-8 z-50 text-white'
        onClick={closeModal}
      >
        <XCircleIcon />
      </button>
      {
        <Suspense>
          <ResourceEditor
            onCancel={closeModal}
            onSave={handleSave}
            resource={currentModalPayload as Resource}
          />
        </Suspense>
      }
    </Modal>
  );
};
